import React from 'react'
import { map, compose, defaultTo } from 'ramda'

export const openGraphMetaDirectors = compose(map((director) => {
  return [
    <meta property="og:video:director" content={director.name} />
  ]
}), defaultTo([]))
